import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { getAccessScope, saveAccessScope } from '../../services/accessScopeService';
import AssignmentTargetPicker, { EMPTY_TARGETS } from './AssignmentTargetPicker';
import Button from './Button';

const Card = styled.div`
  background: #fff;
  border-radius: 6px;
  padding: 24px;
  box-shadow: 0 1px 4px rgba(0, 66, 66, 0.06);
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

/**
 * Bir sahibin (kapı / kapı grubu) erişim kapsamını düzenler.
 *
 * Props:
 *   scopeUrl: string — GET/PUT edilecek uç, örn. `/v1/gates/{id}/scope`
 *   includeAllHint?: string — "Tümü" kutusunun altındaki açıklama
 */
export default function AccessScopeEditor({ scopeUrl, includeAllHint }) {
  const { t } = useTranslation();
  const [value, setValue] = useState(EMPTY_TARGETS);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let iptal = false;
    setLoading(true);
    (async () => {
      const res = await getAccessScope(scopeUrl);
      if (iptal) return;
      // api.js GET okumalarında REDDETMEZ — gerçek sinyal res.data.status.
      if (res?.data?.status === true) {
        const d = res.data.data || {};
        setValue({
          ...EMPTY_TARGETS,
          ...d,
          excludes: { ...EMPTY_TARGETS.excludes, ...(d.excludes || {}) },
        });
      }
      setLoading(false);
    })();
    return () => { iptal = true; };
  }, [scopeUrl]);

  const kaydet = useCallback(async () => {
    setSaving(true);
    try {
      await saveAccessScope(scopeUrl, value);
    } finally {
      setSaving(false);
    }
  }, [scopeUrl, value]);

  // En az bir dahil-etme hedefi yoksa backend "assignment.targetRequired" ile
  // reddeder; butonu baştan kapatıp gereksiz hata turunu önlüyoruz.
  const hedefVar = !!value.includeAll
    || ['userIds', 'departmentIds', 'titleIds', 'locationIds', 'userGroupIds', 'subTenantIds', 'employeeStatusIds']
      .some((k) => (value[k] || []).length > 0);

  return (
    <Card>
      {/* Kapı / kapı grubu kapsamı AssignmentScopeRequest olarak ScopeWriteService'e yazılır ve
          ScopeMatchService ile uygulanır — ikisi de personel statüsünü (tür 7) taşır. */}
      <AssignmentTargetPicker
        value={value}
        onChange={setValue}
        includeAllHint={includeAllHint}
        showEmployeeStatus
      />
      <Footer>
        <Button onClick={kaydet} disabled={saving || loading || !hedefVar}>
          {t('common.save')}
        </Button>
      </Footer>
    </Card>
  );
}
